import React from "react";
import Helmet from "react-helmet";

import Layout from '../components/layout';

class Homepage extends React.Component {
    render() {
        const siteTitle = "Geezer - UK Weezer tribute";

        return (
            <Layout>
                <Helmet title={siteTitle}/>

                <section id="one" className="main special">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>We play Weezer songs.</h2>
                            </header>
                            <p>We're based in the South East of England.</p>
                            <p>We really like Weezer. We play their songs.</p>
                        </div>
                    </div>
                </section>


                <section id="two" className="main style1 special">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            {/*<header className="major">*/}
                            {/*    <h2>Videos</h2>*/}
                            {/*</header>*/}
                            <div className="embed-responsive embed-responsive-4by3">
                                <iframe className="embed-responsive-item" title={"Geezer at New Slang"}
                                        src="https://www.youtube.com/embed/dlTd-j809j0?rel=0&amp;showinfo=0"
                                        frameBorder="0" allowFullScreen=""></iframe>
                            </div>
                        </div>

                    </div>
                </section>

                <section id="three" className="main style2 special">
                    <div className="container">
                        <header className="major">
                            <h2>Get in touch</h2>
                        </header>
                        <p>We don't bite. We like playing shows. Give us a shout.</p>
                        <ul className="actions uniform">
                            <li><a href="mailto:geezerbanduk@gmail.com" className="button special">Email us</a></li>
                        </ul>
                    </div>
                </section>
            </Layout>
        );
    }
}

export default Homepage;